export class CivilIdentityAdditionalData {
    caseNumber: string;
    additionalPartyDetailsList: any[] = [];
    errorMessages: string;

    constructor(caseNumber: string, detailsList: any[], errorMessages?: string ) {
        this.caseNumber = caseNumber;
        this.additionalPartyDetailsList = detailsList;
        this.errorMessages = errorMessages
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-additional-data.ts